// extracted by mini-css-extract-plugin
export default {"notifyContainer":"PrgsILapw6Wcbja9atNR","notifyText":"mlAOXZDj10_mWo78bTip"};